const DOT = {
  scaduto: "#DC2626",
  in_scadenza: "#F57F17",
  futuro: "#C9BDA0",
  completato: "#C9BDA0",
};

// Small status indicator: red (overdue, soft pulse-glow), orange (upcoming), neutral otherwise.
export default function StatusDot({ status, className = "" }) {
  const color = DOT[status] || DOT.futuro;
  const pulse = status === "scaduto";
  return (
    <span
      data-testid={`status-dot-${status}`}
      className={`inline-block h-2.5 w-2.5 rounded-full shrink-0 ${pulse ? "eq-pulse-glow" : ""} ${className}`}
      style={{ backgroundColor: color }}
    />
  );
}
